/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Team_Manager_Import_Too_Many_RowsInputs */



/**
* | output |
* | --- |
* | "Import up to {max} members at a time. Split the file and try again." |
*
* @param {Team_Manager_Import_Too_Many_RowsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_too_many_rows = /** @type {((inputs: Team_Manager_Import_Too_Many_RowsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Too_Many_RowsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importez au maximum ${i?.max} membres à la fois. Divisez le fichier et réessayez.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Importieren Sie höchstens ${i?.max} Mitglieder auf einmal. Teilen Sie die Datei auf und versuchen Sie es erneut.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importa al massimo ${i?.max} membri alla volta. Dividi il file e riprova.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импортируйте не более ${i?.max} участников за раз. Разделите файл и попробуйте снова.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importa como máximo ${i?.max} miembros a la vez. Divide el archivo e inténtalo de nuevo.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`每次最多导入 ${i?.max} 位成员。请拆分文件后重试。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`一度に読み込めるのは ${i?.max} 人までです。ファイルを分割して再試行してください。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`एक बार में अधिकतम ${i?.max} सदस्य इंपोर्ट करें। फ़ाइल को बाँटकर फिर से कोशिश करें।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Importe no máximo ${i?.max} membros de cada vez. Divida o ficheiro e tente novamente.`)
	return /** @type {LocalizedString} */ (`Import up to ${i?.max} members at a time. Split the file and try again.`)
});